// src/pages/PublicHomePage.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { FiDollarSign, FiLogIn, FiArrowRight } from 'react-icons/fi';
import styles from './PublicHomePage.module.css';

const PublicHomePage: React.FC = () => {
    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <div className={styles.logoArea}>
                    <img src="/Profunding_Azul.png" alt="ProFunding" className={styles.logo} />
                </div>
                <nav className={styles.navMenu}>
                    <Link to="/quienes-somos" className={styles.navLink}>Quiénes Somos</Link>
                    <Link to="/proyectos" className={styles.navLink}>Proyectos</Link>
                </nav>
                <Link to="/login" className={styles.loginButton}>
                    <FiLogIn /> Iniciar Sesión
                </Link>
            </header>

            <main className={styles.mainContent}>
                <div className={styles.hero}>
                    <h1 className={styles.heroTitle}>Invierte Fácil en Bienes Raíces</h1>
                    <p className={styles.heroSubtitle}>
                        Tu plataforma de crowdfunding inmobiliario segura y transparente.
                    </p>
                    <div className={styles.ctaGroup}>
                        <Link to="/proyectos" className={styles.ctaPrimary}>
                            Explorar Proyectos <FiArrowRight />
                        </Link>
                        <Link to="/quienes-somos" className={styles.ctaSecondary}>
                            <FiDollarSign /> Conoce Profunding
                        </Link>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default PublicHomePage;